import { Box, Container, Typography, Button, Paper, styled } from '@mui/material';

export const ForgotPasswordContainer = styled(Container)({
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
});

export const ForgotPasswordWrapper = styled(Paper)({
    width: '100%',
    padding: '40px',
    borderRadius: '16px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
    maxWidth: '520px',
});

export const LogoContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '32px',
    
    '& img': {
        width: '32px',
        height: 'auto',
    },
});

export const FormTitle = styled(Typography)({
    fontSize: '22px',
    fontWeight: '600',
    textAlign: 'left',
    marginBottom: '24px',
});

export const FormDescription = styled(Typography)({
    fontSize: '14px',
    color: '#666',
    marginBottom: '16px',
});

export const ButtonsContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: '24px',
    width: '100%',
});

export const BackButton = styled(Button)({
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '500',
    textTransform: 'none',
    color: '#555555',
    backgroundColor: '#F5F5F5',
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: '#EAEAEA',
        boxShadow: 'none',
    },
});

export const SubmitButton = styled(Button)({
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '500',
    textTransform: 'none',
    backgroundColor: '#0058A0',
    color: 'white',
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: '#153366',
        boxShadow: 'none',
    },
    '&:disabled': {
        backgroundColor: '#cccccc',
        boxShadow: 'none',
    },
}); 